
        var result = require("!!../../../../node_modules/css-loader/index.js!./employee-salary.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/employees/employee-details/employee-salary.component.css
// module id = 2458
// module chunks = 1